export { default } from '@triptyk/ember-utils/utils/to';
